<template>
    <div>
        {{ row.total_attendance | commaNumber }}
        <diff-indicator
            v-if="row.diff_attendance_last_week !== null"
            label="LW"
            :primary="row.diff_attendance_last_week"
            primary-filter="commaNumber"
            :secondary="row.diff_attendance_percentage_last_week / 100"
            secondary-filter="percentage"
        />

        <diff-indicator
            v-if="row.diff_attendance_last_year !== null"
            label="LS"
            :primary="row.diff_attendance_last_year"
            primary-filter="commaNumber"
            :secondary="row.diff_attendance_percentage_last_year / 100"
            secondary-filter="percentage"
        />
    </div>
</template>


<script>
import DiffIndicator from 'src/components/DiffIndicator';

export default {
    props: ['row'],
    components: {
        DiffIndicator,
    },
};
</script>
